export default "__VITE_ASSET__C6XEf$$Z__"